export default __webpack_public_path__ + "static/media/master.16580b13.svg";